import { render, staticRenderFns } from "./DiskSpaceMonitoring.vue?vue&type=template&id=467e366a"
import script from "./DiskSpaceMonitoring.vue?vue&type=script&lang=js"
export * from "./DiskSpaceMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports